module.exports = __webpack_public_path__ + "static/img/gy.85cb98f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gy.png
// module id = Zzzk
// module chunks = 1